<script setup lang="ts">
const props = withDefaults(defineProps<{
  buttonMode?: boolean;
}>(), {
  buttonMode: false,
});

const chainStore = useChainStore();

const isFiatMode = computed({
  get () { return chainStore.fiatMode; },
  set () { chainStore.fiatMode = !chainStore.fiatMode; }
});

function toggle() {
  if (props.buttonMode) {
    chainStore.fiatMode = !chainStore.fiatMode;
  }
}
</script>

<template>

  <!-- Button mode -->
  <UButton
    v-if="buttonMode"
    color="white"
    @click="toggle">
    <UToggle
      :model-value="isFiatMode"
      color="indigo"
      size="xs"
      class="pointer-events-none"
    />
    <span class="text-xs font-mono font-medium text-gray-700 dark:text-gray-200">USD</span>
  </UButton>

  <!-- Toggle mode -->
  <label v-else class="inline-flex items-center space-x-1.5">
    <UToggle
      v-model="isFiatMode"
      color="indigo"
      size="xs"
    />
    <span class="text-xs font-mono font-medium text-gray-700 dark:text-gray-200">USD</span>
  </label>

</template>
